import cn from "classnames";
import { formatDateTimezone, isStartBidPoint, START_POINT_LETTER } from "helpers/bidpoint";
import { dateTimeToView, humanizedTimeDiff } from "helpers/date";
import { bidPointTypesEnum, bidStatusesEnum } from "helpers/enums";
import { pointLetter } from "helpers/system";
import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

const RouteMarker = (props) => {
    const { item, index, markersWithoutTooltips, data, mod, updatePosition, firstLoadPointIndex } = props;
    const { bidStatus } = data || {};

    const isActive = bidStatus === bidStatusesEnum.Started || bidStatus === bidStatusesEnum.Done;

    // decide which date to use, auto dates in the priority
    const factOrAutoEnteredAt = item.enteredAtByLogist || item.autoEnteredAt || item.enteredAt;
    const factOrAutoLeftAt = item.enteredAtByLogist || item.autoLeavedAt || item.autoLeftAt || item.loadUnloadedAt;

    const enterLatePeriod = humanizedTimeDiff(item.planEnterDateOffset, factOrAutoEnteredAt);
    const leaveLatePeriod = humanizedTimeDiff(item.planLeaveDateOffset, factOrAutoLeftAt);

    const enteredOnTime = enterLatePeriod && enterLatePeriod.charAt(0) !== "-";
    const leftOnTime = leaveLatePeriod && leaveLatePeriod.charAt(0) !== "-";

    const enteredLate = enterLatePeriod && enterLatePeriod.charAt(0) === "-";
    const leftLate = leaveLatePeriod && leaveLatePeriod.charAt(0) === "-";

    const isLate = enteredLate || leftLate;
    const isOnTime = enteredOnTime || leftOnTime;

    const utcTimezone = formatDateTimezone(item);
    const { city, village, county, address } = item.geozone;

    const isBetweenGeopoint = mod === "create-route" && (item.panelType === "geopoint" || !item.panelType);

    const className = cn("route-icon", {
        "route-icon--late": isActive && isLate,
        "route-icon--schedule": isActive && isOnTime,
        "route-icon--between": isBetweenGeopoint,
    });

    const { coordinates } = item.geozone.location;
    const inverted = [coordinates[1], coordinates[0]];

    const markerContent = () => {
        if (isStartBidPoint(item.geozone.type)) {
            return START_POINT_LETTER;
        }
        if (item.geozone.type === bidPointTypesEnum.ServicePoint) {
            return "<i class='icon-uEA97-wrench' />";
        } else {
            return pointLetter(index, firstLoadPointIndex);
        }
    };
    const iconOptions = isBetweenGeopoint ? { iconSize: [15, 15] } : { iconSize: [30, 30], html: markerContent() };
    const id = item.id || item.i;
    const options = {
        id,
        position: inverted,
        icon: divIcon({ className, ...iconOptions }),
        draggable: data?.canDrag,
        pointType: item.type,
        zIndexOffset: 1000,
        eventHandlers: {
            dragend: (props) => updatePosition(item, props),
            dragstart: ({ target }) => target._icon.classList.add("route-icon--draged"),
        },
    };
    return (
        <Marker {...options}>
            {!markersWithoutTooltips && (
                <Tooltip
                    className="map__tooltip-route-marker map__tooltip-route-marker--dark leaflet-tooltip--left-align leaflet-tooltip--light"
                    direction="top"
                >
                    <div className="route-icon__time-tooltip--header pb-1">
                        <span className="b-timeline-point__city--name">{city || village || county}</span>
                        <small className="text-muted">&nbsp;{utcTimezone}</small>
                    </div>
                    <div className="b-timeline-point__city--full pb-2">{address}</div>
                    <div className="route-icon__time-tooltip">
                        <div />
                        <div className="font-weight-bold">Въезд</div>
                        <div className="font-weight-bold">Выезд</div>
                        <div className="font-weight-bold">План</div>
                        <div>
                            {dateTimeToView(item.planEnterDateOffset || item.planEnterDate)}
                            {(item.secondaryPlanEnterDateOffset || item.secondaryPlanEnterDate) && (
                                <>
                                    <br />
                                    {dateTimeToView(item.secondaryPlanEnterDateOffset || item.secondaryPlanEnterDate)}
                                </>
                            )}
                        </div>
                        <div>{dateTimeToView(item.planLeaveDateOffset)}</div>
                        {item.planLeaveDateOffset ? (
                            <>
                                <div className="font-weight-bold">Факт</div>
                                {!!factOrAutoEnteredAt && enterLatePeriod && enterLatePeriod !== "0" ? (
                                    <div>
                                        {dateTimeToView(factOrAutoEnteredAt)}
                                        <br />
                                        <span
                                            className={cn("route-icon__time-tooltip--small-text", {
                                                "text-danger": enteredLate,
                                                "text-success": !enteredLate,
                                            })}
                                        >
                                            ({enterLatePeriod.slice(enteredLate ? 1 : 0)})
                                        </span>
                                    </div>
                                ) : (
                                    <div />
                                )}
                            </>
                        ) : (
                            <div />
                        )}
                        {!!factOrAutoLeftAt && leaveLatePeriod && leaveLatePeriod !== "0" ? (
                            <div>
                                {dateTimeToView(factOrAutoLeftAt)}
                                <br />
                                <span
                                    className={cn("route-icon__time-tooltip--small-text", {
                                        "text-danger": leftLate,
                                        "text-success": !leftLate,
                                    })}
                                >
                                    ({leaveLatePeriod.slice(leftLate ? 1 : 0)})
                                </span>
                            </div>
                        ) : (
                            <div />
                        )}
                    </div>
                </Tooltip>
            )}
        </Marker>
    );
};

export default RouteMarker;
